export function gatAvailability(
    availabilityType,
    date,
    allotmentType,
    categoryName = null,
    serviceName = null,
    subAllotment = null
) {
    const availabilities = availabilityType.filter(
        availability =>
            new Date(`${availability.dateFrom}T00:00`) <= date &&
            date <= new Date(`${availability.dateTo}T23:59`) &&
            availability.allotmentType === allotmentType &&
            (!categoryName || availability.categoryName === categoryName) &&
            (!serviceName || availability.serviceName === serviceName) &&
            (!subAllotment || availability.subAllotmentId === subAllotment.id)
    )
    if (!availabilities.length) return null
    // TODO [P0] How to reduce release and status and other params
    return availabilities.reduce(
        (totalAvailability, availability) => {
            // TODO [P0] How to reduce availableQuantity with canBeUndefined
            if (!availability.canBeUndefined || !totalAvailability.availableQuantity) {
                totalAvailability.allocatedQuantity += availability.allocatedQuantity
                totalAvailability.availableQuantity += availability.availableQuantity
                totalAvailability.bookedQuantity += availability.bookedQuantity
            }
            totalAvailability.release = availability.release
            totalAvailability.status =
                availabilities.length === 1
                    ? availability.status
                    : availabilities.every(({status}) => status === 'UNLIMITED')
                      ? 'UNLIMITED'
                      : availabilities.every(({status}) => status === 'RELEASED')
                        ? 'RELEASED'
                        : availabilities.find(
                                ({status, availableQuantity}) =>
                                    ['AVAILABLE', 'OVERBOOKING'].includes(status) && availableQuantity
                            )
                          ? 'AVAILABLE'
                          : availabilities.every(({status}) => status === 'BLOCKED')
                            ? 'BLOCKED'
                            : availabilities.every(({status}) => status === 'TERMINATED_ALLOTMENT')
                              ? 'TERMINATED_ALLOTMENT'
                              : null
            totalAvailability.canBeUndefined = availabilities.length === 1 && availability.canBeUndefined
            return totalAvailability
        },
        {
            allocatedQuantity: 0,
            availableQuantity: 0,
            bookedQuantity: 0,
            status: null,
            release: 0,
            canBeUndefined: false,
        }
    )
}

export function hasAnyAvailability(availabilityType, dates, allotmentType, subAllotment = null) {
    return !!dates.find(date =>
        ['AVAILABLE', 'UNLIMITED', 'RELEASED', 'OVERBOOKING', 'BLOCKED', 'TERMINATED_ALLOTMENT'].includes(
            gatAvailability(availabilityType, date, allotmentType, null, null, subAllotment)?.status
        )
    )
}
